export enum FONT_WEIGHTS {
  NORMAL = 400,
  BOLD = 500,
  EXTRA_BOLD = 900
}

export default FONT_WEIGHTS;
